export default class {
    _id;
    _number;
    _date;
    _status;
    _correctDate;
    _correctDocumentUid;
    _correctNumber;
    _contractNumber;
    _contractDate;
    _createdOn;
    _isCustomerApproved;
    _customerApprovedOn;
    _isExecutorApproved;
    _executorApprovedOn;
    _executorDetails;
    _customerDetails;
    _total;
    _totalInWords;
    _executorDirector;
    _executorAccountant;
    _executorReleaser;
    _customerProxyNumber;
    _customerProxyDate;
    _customerProxyName;
    _shipment;


    get id() {
        return this._id
    }

    set id(value) {
        this._id = value
    }

    get number() {
        return this._number
    }

    set number(value) {
        this._number = value
    }

    get status() {
        return this._status
    }

    set status(value) {
        this._status = value
    }

    get date() {
        return this._date
    }

    set date(value) {
        this._date = value
    }

    get contractNumber() {
        return this._contractNumber
    }

    set contractNumber(value) {
        this._contractNumber = value
    }

    get contractDate() {
        return this._contractDate
    }

    set contractDate(value) {
        this._contractDate = value
    }

    get createdOn() {
        return this._createdOn
    }

    set createdOn(value) {
        this._createdOn = value
    }

    get isCustomerApproved() {
        return this._isCustomerApproved
    }

    set isCustomerApproved(value) {
        this._isCustomerApproved = value
    }

    get customerApprovedOn() {
        return this._customerApprovedOn
    }

    set customerApprovedOn(value) {
        this._customerApprovedOn = value
    }

    get isExecutorApproved() {
        return this._isExecutorApproved
    }

    set isExecutorApproved(value) {
        this._isExecutorApproved = value
    }

    get executorApprovedOn() {
        return this._executorApprovedOn
    }

    set executorApprovedOn(value) {
        this._executorApprovedOn = value
    }

    get executorDetails() {
        return this._executorDetails
    }

    set executorDetails(value) {
        this._executorDetails = value
    }

    get customerDetails() {
        return this._customerDetails
    }

    set customerDetails(value) {
        this._customerDetails = value
    }

    get total() {
        return this._total
    }

    set total(value) {
        this._total = value
    }

    get totalInWords() {
        return this._totalInWords
    }

    set totalInWords(value) {
        this._totalInWords = value
    }

    get executorDirector() {
        return this._executorDirector
    }

    set executorDirector(value) {
        this._executorDirector = value
    }

    get executorAccountant() {
        return this._executorAccountant
    }

    set executorAccountant(value) {
        this._executorAccountant = value
    }

    get executorReleaser() {
        return this._executorReleaser
    }

    set executorReleaser(value) {
        this._executorReleaser = value
    }

    get customerProxyNumber() {
        return this._customerProxyNumber
    }

    set customerProxyNumber(value) {
        this._customerProxyNumber = value
    }

    get customerProxyDate() {
        return this._customerProxyDate
    }

    set customerProxyDate(value) {
        this._customerProxyDate = value
    }

    get customerProxyName() {
        return this._customerProxyName
    }

    set customerProxyName(value) {
        this._customerProxyName = value
    }

    get shipment() {
        return this._shipment
    }

    set shipment(value) {
        this._shipment = value
    }

    get correctDate() {
        return this._correctDate
    }

    set correctDate(value) {
        this._correctDate = value
    }

    get correctDocumentUid() {
        return this._correctDocumentUid
    }

    set correctDocumentUid(value) {
        this._correctDocumentUid = value
    }

    get correctNumber() {
        return this._correctNumber
    }

    set correctNumber(value) {
        this._correctNumber = value
    }
}